module.exports = __webpack_public_path__ + "media/images/lb/163-85835775aec4378189e1223f82cb5b3d.svg";